'use client';

import { NonCrawlableLink } from '../../../../components/Clickables/NonCrawlableLink/NonCrawlableLink';
import { Container } from '../../../../components/Container/Container';
import { Heading } from '../../../../components/Heading/Heading';
import { Text } from '../../../../components/Text/Text';
import { useAnalytics } from '@domain/analytics/AnalyticsContext';
import { trackEvent } from '@domain/analytics/trackEvent';
import { getSuggestWaterChangesUrl } from '@domain/routes/urls';
import { SUB_LINK_IDS } from '../../helpers/fishingWaterHelpers';

interface IProps {
  fishingWaterId: string;
  displayName: string;
}

export const SuggestChangesSection = ({ fishingWaterId, displayName }: IProps) => {
  const { currentPage } = useAnalytics();

  return (
    <Container
      id={SUB_LINK_IDS.SUGGEST_CHANGES}
      className="mb-md flex scroll-mt-(--navigation-scrolltop-offset-mobile) flex-col justify-center sm:mx-auto sm:max-w-md sm:scroll-mt-(--navigation-scrolltop-offset) md:max-w-lg"
    >
      <Heading variant="xs" className="mb-2 text-center">
        Anything missing or inaccurate?
      </Heading>
      <Text variant="sm" className="mb-6 text-center">
        Suggest changes to improve what we show.
      </Text>
      <div className="mx-auto">
        <NonCrawlableLink
          variant="buttonSecondary"
          routerPushTo={getSuggestWaterChangesUrl(fishingWaterId, displayName)}
          onClickEvent={() => {
            trackEvent({
              name: 'mykiss_cta_button_clicked',
              properties: {
                type: 'read-more',
                source: 'suggest-edit',
                page: currentPage,
              },
            });
          }}
          ariaLabel="suggest changes to this fishing water"
        >
          Suggest changes
        </NonCrawlableLink>
      </div>
    </Container>
  );
};
